// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2UJSN","cell":"ColumnAccessor_cell__VtirR","firstCellAccent":"ColumnAccessor_firstCellAccent__gh6R8"};